import React from 'react';
import { useHistory } from 'react-router';
import { useFormik } from 'formik';
import { Button, TextField, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import LoginForm from './schemas/LoginForm';
import { loginEmail } from 'services/authServices';
import AppContext from 'contexts/AppContext';
import UserRoleType from 'types/enums/UserRoleType';

export default (): JSX.Element => {
  const history = useHistory();
  const { setAuthData } = React.useContext(AppContext);
  const [showErrorMessage, setShowErrorMessage] = React.useState(false);
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: LoginForm(t),
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append('email', values.email.trim());
      formData.append('password', values.password);

      const result = await loginEmail(formData);

      if (result) {
        localStorage.setItem('auth-data', JSON.stringify(result));
        setAuthData(result);
        setShowErrorMessage(false);
        if (result?.user?.role === UserRoleType.Admin || result?.user?.role === UserRoleType.VenueEditor) {
          history.push('/private/venues');
        } else if (result?.user?.role === UserRoleType.WarehouseEditor) {
          history.push('/private/stock/warehouses');
        } else {
          history.push('/private/commerces');
        }
      } else {
        setShowErrorMessage(true);
        formik.setSubmitting(false);
      }
    },
  });

  return (
    <>
      {showErrorMessage && (
        <Typography className="btn-50" color="error">
          {t('login-form-error')}
        </Typography>
      )}
      <form onSubmit={formik.handleSubmit} className="btn-50">
        <TextField
          margin="dense"
          fullWidth
          id="email"
          name="email"
          label={t('login-form-email')}
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          disabled={formik.isSubmitting}
        />
        <TextField
          margin="dense"
          fullWidth
          id="password"
          name="password"
          label={t('login-form-password')}
          value={formik.values.password}
          onChange={formik.handleChange}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
          disabled={formik.isSubmitting}
        />
        <div className="footer">
          <Button fullWidth variant="contained" color="primary" type="submit" disabled={formik.isSubmitting}>
            {t('login-form-login')}
          </Button>
        </div>
      </form>
    </>
  );
};
